// libs
import { useMemo } from 'react';

import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// helpers
import { log } from 'shared/helpers/newRelic';
import { TAG_IDENTIFIER, ERROR_TAGS } from 'shared/helpers/newRelic/constants';

// constants
import { WIDGET_RC_PDP_BANNER_WIDGET } from 'shared/layouts/DetailsPage/constants';
import {
  IWidgetConfig,
  IDwebWidgetType,
} from 'shared/layouts/DetailsPage/components/Widgets/types';

const PDP_WIDGET_MODULE = 'Pdp Widgets';

interface WidgetLoaderProps {
  isMobile?: boolean;
}

const useWidgetLoader = ({ isMobile = false }: WidgetLoaderProps) => {
  const deviceType = isMobile ? 'mobile' : 'desktop';

  const widgetConfig = (useRemoteConfig(`widget.${deviceType}`) as IWidgetConfig) || [];

  // Uses Remote Config data of key widget: { mobile, desktop } and transforms
  // { algo: "", widget_type: "" } to { widget_name: "algo" } as
  // the later format is consumed/required by the api.

  const transformedWidgetData = useMemo(() => {
    try {
      if (!isMobile) {
        return JSON.stringify(widgetConfig || '');
      }
      const mobileWidgetConfig = widgetConfig || '';

      let modifiedApiConfig = [];

      for (const currentWidget of mobileWidgetConfig) {
        const key = Object.keys(currentWidget)[0];
        if (key === WIDGET_RC_PDP_BANNER_WIDGET) {
          continue;
        }
        const modifiedWidget: IDwebWidgetType = {};
        modifiedWidget[key] = currentWidget[key].algo;

        modifiedApiConfig.push(modifiedWidget);
      }

      return JSON.stringify(modifiedApiConfig);
    } catch (error) {
      log({
        errTitle: 'Error in getting remote config value - widget loader',
        tags: {
          [TAG_IDENTIFIER.ERROR]: ERROR_TAGS.FIREBASE_CONFIG_FAILURE,
          [TAG_IDENTIFIER.MODULE]: PDP_WIDGET_MODULE,
        },
      });
      return '';
    }
  }, [isMobile, widgetConfig]);

  return {
    widgetConfig,
    transformedWidgetData,
  };
};

export default useWidgetLoader;
